import React, { Component } from "react";
import * as Connection from "./../libs/connections";
import { Redirect } from "react-router-dom";
import $ from "jquery";

import Preloader from "./../components/global/Preloader";
import SectionImageText from "./../components/SectionImageText";
import HeroBannerSmall from "../components/HeroBannerSmall";
import SectionContact from "../components/SectionContact";
import SectionAboutUs from "../components/SectionAboutUs";

import TrackLineGrey from "../assets/icons-main/track-grey.svg";
import TrackLineOrange from "../assets/icons-main/track-orange.svg";
import heroBackground from "../assets/header/header-o-marce.svg";

import "../styles/sites/AboutUsPage.css";

export default class AboutUsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      error: false,
      elements: []
    };
  }

  async componentDidMount() {
    try {
      const response = await Connection.getSinglePage("o-marce");
      this.setState({
        loading: false,
        elements: response.acf.elements
      });
    } catch (err) {
      this.setState({
        error: true
      });
    }

    $(document).ready(function() {
      window.onscroll = function(event) {
        const offset = window.pageYOffset;
        const wheight = window.innerHeight;
        const html = document.documentElement;
        const docheight = Math.max(
          document.body.scrollHeight,
          document.body.offsetHeight,
          html.clientHeight,
          html.scrollHeight,
          html.offsetHeight
        );
        const progress = ((offset / (docheight - wheight)) * 100).toPrecision(
          4
        );

        $(".page__about-us #fillshape").attr("y", progress + "%");
      };
    });
  }

  render() {
    const params = [
      {
        wrapperClasses: "container version-1",
        paddingTop: 230,
        paddingBottom: 380
      },
      {
        wrapperClasses: "container container-small version-2",
        paddingTop: 250,
        paddingBottom: 300
      },
      {
        wrapperClasses: "container container-small version-3 text-center",
        paddingTop: 490,
        paddingBottom: 430
      }
    ];
    if (!this.state.error) {
      return (
        <div className="page__about-us">
          <HeroBannerSmall
            backgroundImage={heroBackground}
            changeOpacity={true}
            fontSize={120}
            headerText={"Marka V1RAGE"}
          />
          <Preloader global loading={this.state.loading} />
          <div className="page__about-us--wrapper">
            <div className="track-line">
              <img src={TrackLineGrey} className="svg svg-grey" alt="" />
              <img src={TrackLineOrange} className="svg svg-orange" alt="" />
              <img src={TrackLineGrey} className="svg svg-white" alt="" />
            </div>
            {this.state.elements.length > 0 &&
              this.state.elements.map((item, idx) => {
                const elem = params[idx];
                return (
                  <React.Fragment key={idx}>
                    <SectionAboutUs data={item} version={++idx} />;
                    <SectionImageText
                      text={item["text_background_parallax"]}
                      wrapperClasses={elem["wrapperClasses"]}
                      backgroundImage={item["photo_background_parallax"]}
                      paddingTop={elem["paddingTop"]}
                      paddingBottom={elem["paddingBottom"]}
                    />
                  </React.Fragment>
                );
              })}
            <SectionContact version={1} pageType="send-form-about-us" />
          </div>
        </div>
      );
    } else {
      return <Redirect to="/error" />;
    }
  }
}
